<template>
  <SettingsForm
    :slides="slides"
    :interval="interval"
    @update-settings="updateSettings"
    :submissions="submissions"
    :students="students"
    @save-submissions="updateSubmissions"
    @save-students="updateStudents"
  />
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import SettingsForm from '../components/SettingsForm.vue';

export default {
  components: { SettingsForm },
  computed: {
    ...mapGetters([
      'slides', 'interval', 'submissions', 'students'
    ])
  },
  methods: {
    ...mapMutations([
      'updateSlides', 'updateInterval', 'saveSubmissions', 'saveStudents'
    ]),
    updateSettings({ slides, interval }) {
      this.updateSlides(slides);
      this.updateInterval(interval);
      this.$router.push('/');
    },
    updateSubmissions(submissions) {
      this.saveSubmissions(submissions);
    },
    updateStudents(students) {
      this.saveStudents(students);
    }

  }
};
</script>
